import { render, staticRenderFns } from "./LanguageModal.vue?vue&type=template&id=7f9a955a&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a955a",
  null
  
)

export default component.exports